import PropTypes from 'prop-types';
import React from 'react'
import { withRouter } from 'react-router-dom';
import { findWhere, filter } from 'underscore'


class OtherInterests extends React.Component {

    static propTypes = {
		interests: PropTypes.array.isRequired,
		slug: PropTypes.string
	};

    changeFilter = (e) => {
		let interest = findWhere( this.props.interests, {slug: e.target.value} )
		if( interest.slug !== e.target.value ) return
		this.props.history.push( `/discover/${interest.slug}` )
	};

    render() {

		let slug = !!this.props.slug ? this.props.slug : '',
			interests = filter(this.props.interests, {hidden: false});

		return (

			<select className="other-interests" onChange={this.changeFilter} value={ slug }>

				<option value="">Other Interests</option>

				{
					interests.map(interest => {
						return <option value={interest.slug} key={'other-interests-'+interest.ID}>
							{interest.title}
						</option>
					} )
				}
				
			</select>

		)
		
	}
}

export default withRouter(OtherInterests);


// WEBPACK FOOTER //
// ./src/js/views/Discover/components/Filters/components/OtherInterests.jsx